function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _regeneratorValues(e) { if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
    if (t)
        return t.call(e);
    if ("function" == typeof e.next)
        return e;
    if (!isNaN(e.length))
        return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } };
} throw new TypeError(_typeof(e) + " is not iterable"); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { DeleteOutlined as DeleteIcon } from '@mui/icons-material';
import { Alert, Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, FormControl, IconButton, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { UserAPI } from '../apis/UserAPI';
import { constants } from '../constants';
var isWorkspaceOnlyRole = function isWorkspaceOnlyRole(role) {
    // No application_id at all
    if (!role.application_id)
        return true;
    // Handle string type
    if (typeof role.application_id === 'string') {
        var trimmed = role.application_id.trim().toLowerCase();
        return trimmed === '' || trimmed === '0' || trimmed === 'null' || trimmed === 'undefined';
    }
    // Handle array type
    if (Array.isArray(role.application_id)) {
        // Empty array
        if (role.application_id.length === 0)
            return true;
        // Array with only null, undefined, empty strings, "0", or "null" strings
        return role.application_id.every(function (id) {
            if (id === null || id === undefined)
                return true;
            if (typeof id === 'string') {
                var _trimmed = id.trim().toLowerCase();
                return _trimmed === '' || _trimmed === '0' || _trimmed === 'null' || _trimmed === 'undefined';
            }
            return false;
        });
    }
    return false;
};
var UserDetailsModal = function UserDetailsModal(_ref) {
    var open = _ref.open, onClose = _ref.onClose, user = _ref.user, onDelete = _ref.onDelete, onWorkspaceRoleChange = _ref.onWorkspaceRoleChange, onApplicationRoleChange = _ref.onApplicationRoleChange;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), applications = _useState2[0], setApplications = _useState2[1];
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), roles = _useState4[0], setRoles = _useState4[1];
    var _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), applicationAccess = _useState6[0], setApplicationAccess = _useState6[1];
    var _useState7 = useState([]), _useState8 = _slicedToArray(_useState7, 2), workspaceRoles = _useState8[0], setWorkspaceRoles = _useState8[1];
    var _useState9 = useState(false), _useState0 = _slicedToArray(_useState9, 2), loading = _useState0[0], setLoading = _useState0[1];
    var _useState1 = useState(null), _useState10 = _slicedToArray(_useState1, 2), error = _useState10[0], setError = _useState10[1];
    var _useState11 = useState({}), _useState12 = _slicedToArray(_useState11, 2), updateLoading = _useState12[0], setUpdateLoading = _useState12[1];
    // Load applications and roles when modal opens
    useEffect(function () {
        if (open && user) {
            loadApplicationsAndRoles();
            // Reset workspace roles when modal opens to ensure fresh data
            setWorkspaceRoles([]);
        }
        else if (!open) {
            // Reset state when modal closes
            setWorkspaceRoles([]);
            setApplicationAccess([]);
            setError(null);
        }
    }, [open, user]);
    // Set initial workspace roles when user changes
    useEffect(function () {
        if (user && roles.length > 0) {
            var userRoles = Array.isArray(user.role) ? user.role : [user.role];
            var workspaceOnlyRoles = roles.filter(isWorkspaceOnlyRole);
            // Find all user roles that are workspace-only
            var userWorkspaceRoles = userRoles.filter(function (roleName) {
                return workspaceOnlyRoles.some(function (role) {
                    return role.role_name === roleName;
                });
            });
            setWorkspaceRoles(userWorkspaceRoles);
        }
    }, [user, roles]);
    var loadApplicationsAndRoles = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var _yield$Promise$all, _yield$Promise$all2, appsResponse, rolesResponse, roleMatchesApp, getRolesForApp, userRoles, _applicationAccess, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            setLoading(true);
                            _context.p = 1;
                            _context.n = 2;
                            return Promise.all([UserAPI.getAllApplications(), UserAPI.getRoles()]);
                        case 2:
                            _yield$Promise$all = _context.v;
                            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                            appsResponse = _yield$Promise$all2[0];
                            rolesResponse = _yield$Promise$all2[1];
                            setApplications(appsResponse.resource);
                            setRoles(rolesResponse.resource);
                            // Helper to check if role belongs to an application
                            roleMatchesApp = function roleMatchesApp(role, appId) {
                                var appIds = Array.isArray(role.application_id) ? role.application_id : [role.application_id];
                                return appIds.some(function (id) {
                                    return String(id) === String(appId);
                                });
                            }; // Helper to get roles for an application
                            getRolesForApp = function getRolesForApp(appId) {
                                return rolesResponse.resource.filter(function (role) {
                                    return roleMatchesApp(role, appId);
                                }).map(function (role) {
                                    return role.role_name;
                                });
                            }; // Build application access data using user's actual roles
                            if (user) {
                                userRoles = Array.isArray(user.role) ? user.role : [user.role];
                                _applicationAccess = appsResponse.resource.map(function (app) {
                                    var appRoles = getRolesForApp(app.id);
                                    // Find which of the user's roles belong to this application
                                    var userAppRoles = userRoles.filter(function (userRole) {
                                        return appRoles.includes(userRole);
                                    });
                                    return {
                                        applicationName: app.name,
                                        accessLevel: userAppRoles,
                                        // User's actual roles for this app
                                        availableRoles: appRoles // All available roles for this app
                                    };
                                });
                                setApplicationAccess(_applicationAccess);
                            }
                            _context.n = 4;
                            break;
                        case 3:
                            _context.p = 3;
                            _t = _context.v;
                            // Failed to load applications and roles - silently handle
                            setError("".concat(constants.user_details_load_failed, " ").concat(_t));
                        case 4:
                            _context.p = 4;
                            setLoading(false);
                            return _context.f(4);
                        case 5:
                            return _context.a(2);
                    }
            }, _callee, null, [[1, 3, 4, 5]]);
        }));
        return function loadApplicationsAndRoles() {
            return _ref2.apply(this, arguments);
        };
    }();
    var handleWorkspaceRoleChange = function handleWorkspaceRoleChange(event) {
        var newRoles = event.target.value;
        setWorkspaceRoles(newRoles);
        if (user && onWorkspaceRoleChange) {
            onWorkspaceRoleChange(user.id, newRoles);
        }
    };
    var processRoleChanges = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(app, rolesToAdd, rolesToRemove) {
            var _iterator, _step, _loop, _iterator2, _step2, _loop2, _t2, _t3;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.p = _context4.n) {
                        case 0:
                            _iterator = _createForOfIteratorHelper(rolesToAdd);
                            _context4.p = 1;
                            _loop = /*#__PURE__*/ _regenerator().m(function _loop() {
                                var roleName, roleObj;
                                return _regenerator().w(function (_context2) {
                                    while (1)
                                        switch (_context2.n) {
                                            case 0:
                                                roleName = _step.value;
                                                roleObj = roles.find(function (r) {
                                                    var appIds = Array.isArray(r.application_id) ? r.application_id : [r.application_id];
                                                    return r.role_name === roleName && appIds.some(function (id) {
                                                        return String(id) === String(app.id);
                                                    });
                                                });
                                                if (!(roleObj && user)) {
                                                    _context2.n = 1;
                                                    break;
                                                }
                                                _context2.n = 1;
                                                return UserAPI.assignRole(user.email, {
                                                    roleId: Number.parseInt(roleObj.role_id)
                                                });
                                            case 1:
                                                return _context2.a(2);
                                        }
                                }, _loop);
                            });
                            _iterator.s();
                        case 2:
                            if ((_step = _iterator.n()).done) {
                                _context4.n = 4;
                                break;
                            }
                            return _context4.d(_regeneratorValues(_loop()), 3);
                        case 3:
                            _context4.n = 2;
                            break;
                        case 4:
                            _context4.n = 6;
                            break;
                        case 5:
                            _context4.p = 5;
                            _t2 = _context4.v;
                            _iterator.e(_t2);
                        case 6:
                            _context4.p = 6;
                            _iterator.f();
                            return _context4.f(6);
                        case 7:
                            _iterator2 = _createForOfIteratorHelper(rolesToRemove);
                            _context4.p = 8;
                            _loop2 = /*#__PURE__*/ _regenerator().m(function _loop2() {
                                var roleName, roleObj;
                                return _regenerator().w(function (_context3) {
                                    while (1)
                                        switch (_context3.n) {
                                            case 0:
                                                roleName = _step2.value;
                                                roleObj = roles.find(function (r) {
                                                    var appIds = Array.isArray(r.application_id) ? r.application_id : [r.application_id];
                                                    return r.role_name === roleName && appIds.some(function (id) {
                                                        return String(id) === String(app.id);
                                                    });
                                                });
                                                if (!(roleObj && user)) {
                                                    _context3.n = 1;
                                                    break;
                                                }
                                                _context3.n = 1;
                                                return UserAPI.removeRole(user.id, Number.parseInt(roleObj.role_id));
                                            case 1:
                                                return _context3.a(2);
                                        }
                                }, _loop2);
                            });
                            _iterator2.s();
                        case 9:
                            if ((_step2 = _iterator2.n()).done) {
                                _context4.n = 11;
                                break;
                            }
                            return _context4.d(_regeneratorValues(_loop2()), 10);
                        case 10:
                            _context4.n = 9;
                            break;
                        case 11:
                            _context4.n = 13;
                            break;
                        case 12:
                            _context4.p = 12;
                            _t3 = _context4.v;
                            _iterator2.e(_t3);
                        case 13:
                            _context4.p = 13;
                            _iterator2.f();
                            return _context4.f(13);
                        case 14:
                            return _context4.a(2);
                    }
            }, _callee2, null, [[8, 12, 13, 14], [1, 5, 6, 7]]);
        }));
        return function processRoleChanges(_x, _x2, _x3) {
            return _ref3.apply(this, arguments);
        };
    }();
    var buildUpdatedRolesList = function buildUpdatedRolesList(applicationName, newAccess) {
        var allApplicationRoles = [];
        var _iterator3 = _createForOfIteratorHelper(applicationAccess), _step3;
        try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var app = _step3.value;
                if (app.applicationName === applicationName) {
                    allApplicationRoles.push.apply(allApplicationRoles, _toConsumableArray(newAccess));
                }
                else {
                    allApplicationRoles.push.apply(allApplicationRoles, _toConsumableArray(app.accessLevel));
                }
            }
        }
        catch (err) {
            _iterator3.e(err);
        }
        finally {
            _iterator3.f();
        }
        return workspaceRoles.length > 0 ? [].concat(_toConsumableArray(workspaceRoles), allApplicationRoles) : allApplicationRoles;
    };
    var handleApplicationAccessChange = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3(applicationName, newAccess) {
            var app, currentApp, currentAccess, rolesToAdd, rolesToRemove, allRoles, _t4;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.p = _context5.n) {
                        case 0:
                            if (user) {
                                _context5.n = 1;
                                break;
                            }
                            return _context5.a(2);
                        case 1:
                            setError(null);
                            setUpdateLoading(function (prev) {
                                return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, applicationName, true));
                            });
                            _context5.p = 2;
                            app = applications.find(function (app) {
                                return app.name === applicationName;
                            });
                            if (app) {
                                _context5.n = 3;
                                break;
                            }
                            throw new Error("Application ".concat(applicationName, " not found"));
                        case 3:
                            currentApp = applicationAccess.find(function (a) {
                                return a.applicationName === applicationName;
                            });
                            currentAccess = (currentApp === null || currentApp === void 0 ? void 0 : currentApp.accessLevel) || [];
                            rolesToAdd = newAccess.filter(function (role) {
                                return !currentAccess.includes(role);
                            });
                            rolesToRemove = currentAccess.filter(function (role) {
                                return !newAccess.includes(role);
                            });
                            _context5.n = 4;
                            return processRoleChanges(app, rolesToAdd, rolesToRemove);
                        case 4:
                            setApplicationAccess(function (prev) {
                                return prev.map(function (app) {
                                    return app.applicationName === applicationName ? _objectSpread(_objectSpread({}, app), {}, {
                                        accessLevel: newAccess
                                    }) : app;
                                });
                            });
                            if (onApplicationRoleChange && user) {
                                allRoles = buildUpdatedRolesList(applicationName, newAccess);
                                onApplicationRoleChange(user.id, allRoles);
                            }
                            _context5.n = 6;
                            break;
                        case 5:
                            _context5.p = 5;
                            _t4 = _context5.v;
                            setError(_t4.message || constants.user_details_update_access_failed);
                        case 6:
                            _context5.p = 6;
                            setUpdateLoading(function (prev) {
                                return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, applicationName, false));
                            });
                            return _context5.f(6);
                        case 7:
                            return _context5.a(2);
                    }
            }, _callee3, null, [[2, 5, 6, 7]]);
        }));
        return function handleApplicationAccessChange(_x4, _x5) {
            return _ref4.apply(this, arguments);
        };
    }();
    var handleDelete = function handleDelete() {
        if (user && onDelete) {
            onDelete(user);
        }
        onClose();
    };
    // Helper function to get workspace-only roles (not assigned to any application)
    var getWorkspaceOnlyRoles = function getWorkspaceOnlyRoles() {
        return roles.filter(isWorkspaceOnlyRole);
    };
    if (!user)
        return null;
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        PaperProps: {
            sx: {
                borderRadius: 2,
                maxHeight: '90vh'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 3,
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 3
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        sx: {
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: '24px',
            color: '#212121',
            lineHeight: 1.52
        }
    }, user.name), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            color: '#595959',
            fontSize: '14px'
        }
    }, constants.user_details_date_added(user.dateAdded))), /*#__PURE__*/ React.createElement(IconButton, {
        onClick: handleDelete,
        sx: {
            color: '#da291c',
            border: '1px solid #da291c',
            borderRadius: '2px',
            width: 40,
            height: 40,
            '&:hover': {
                backgroundColor: 'rgba(218, 41, 28, 0.04)'
            }
        }
    }, /*#__PURE__*/ React.createElement(DeleteIcon, {
        fontSize: "small"
    }))), /*#__PURE__*/ React.createElement(DialogContent, {
        sx: {
            p: 3
        }
    }, error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mb: 3
        },
        onClose: function onClose() {
            return setError(null);
        }
    }, error), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 3,
            p: 2,
            backgroundColor: '#f5f5f5',
            borderRadius: 2,
            border: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontFamily: 'Open Sans',
            fontSize: '14px',
            color: '#212121',
            minWidth: '120px'
        }
    }, constants.user_details_workspace_role), /*#__PURE__*/ React.createElement(FormControl, {
        sx: {
            minWidth: 200
        }
    }, /*#__PURE__*/ React.createElement(Select, {
        multiple: true,
        value: workspaceRoles,
        onChange: handleWorkspaceRoleChange,
        size: "small",
        renderValue: function renderValue(selected) {
            return /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 0.5
                }
            }, selected.length === 0 ? /*#__PURE__*/ React.createElement(Typography, {
                variant: "body2",
                sx: {
                    color: '#999'
                }
            }, constants.user_details_no_roles_selected) : selected.map(function (value) {
                return /*#__PURE__*/ React.createElement(Chip, {
                    key: value,
                    label: value,
                    size: "small",
                    sx: {
                        backgroundColor: '#f3f8eb',
                        color: '#1a5d09',
                        fontFamily: 'Open Sans',
                        fontSize: 12,
                        fontWeight: 600,
                        height: 20
                    }
                });
            }));
        },
        sx: {
            backgroundColor: 'white',
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#d9d9d9'
            }
        }
    }, getWorkspaceOnlyRoles().map(function (role) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: role.role_id,
            value: role.role_name
        }, role.role_name);
    })))), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(TableContainer, {
        component: Paper,
        elevation: 0
    }, /*#__PURE__*/ React.createElement(Table, null, /*#__PURE__*/ React.createElement(TableHead, null, /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: '14px',
            color: '#212121',
            borderBottom: '1px solid #ebebeb',
            width: '300px'
        }
    }, constants.user_details_applications_header_application), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: '14px',
            color: '#212121',
            borderBottom: '1px solid #ebebeb'
        }
    }, constants.user_details_applications_header_access))), /*#__PURE__*/ React.createElement(TableBody, null, applicationAccess.map(function (app, index) {
        return /*#__PURE__*/ React.createElement(TableRow, {
            key: app.applicationName,
            sx: {
                '&:not(:last-child)': {
                    borderBottom: '1px solid #ebebeb'
                }
            }
        }, /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                fontFamily: 'Open Sans',
                fontSize: '14px',
                color: '#212121',
                borderBottom: index === applicationAccess.length - 1 ? 'none' : '1px solid #ebebeb'
            }
        }, app.applicationName), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                borderBottom: index === applicationAccess.length - 1 ? 'none' : '1px solid #ebebeb'
            }
        }, /*#__PURE__*/ React.createElement(FormControl, {
            sx: {
                minWidth: 200
            }
        }, /*#__PURE__*/ React.createElement(Select, {
            multiple: true,
            value: app.accessLevel,
            onChange: function onChange(e) {
                return handleApplicationAccessChange(app.applicationName, e.target.value);
            },
            size: "small",
            disabled: updateLoading[app.applicationName] || loading,
            renderValue: function renderValue(selected) {
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 0.5,
                        alignItems: 'center'
                    }
                }, updateLoading[app.applicationName] && /*#__PURE__*/ React.createElement(CircularProgress, {
                    size: 16,
                    sx: {
                        mr: 1
                    }
                }), selected.length === 0 ? /*#__PURE__*/ React.createElement(Typography, {
                    variant: "body2",
                    sx: {
                        color: '#999'
                    }
                }, constants.user_details_no_roles_selected) : selected.map(function (value) {
                    return /*#__PURE__*/ React.createElement(Chip, {
                        key: value,
                        label: value,
                        size: "small",
                        sx: {
                            backgroundColor: '#f3f8eb',
                            color: '#1a5d09',
                            fontFamily: 'Open Sans',
                            fontSize: 12,
                            fontWeight: 600,
                            height: 20
                        }
                    });
                }));
            },
            sx: {
                backgroundColor: 'white',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#d9d9d9'
                }
            }
        }, app.availableRoles.map(function (role) {
            return /*#__PURE__*/ React.createElement(MenuItem, {
                key: role,
                value: role
            }, role);
        })))));
    })))))), /*#__PURE__*/ React.createElement(DialogActions, {
        sx: {
            p: 3,
            borderTop: '1px solid #d9d9d9',
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: onClose,
        variant: "contained",
        sx: {
            backgroundColor: '#26890d',
            color: 'white',
            textTransform: 'none',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: '16px',
            px: 4,
            py: 1.5,
            '&:hover': {
                backgroundColor: '#1a5d09'
            }
        }
    }, constants.close)));
};
export default UserDetailsModal;
